var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","dark":"","fixed":"","bottom":"","right":"","fab":"","href":"https://m.me/myroomabroad","target":"_blank"}},[_c('v-icon',{attrs:{"id":"fbContactButton"}},[_vm._v("forum")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }